// extracted by mini-css-extract-plugin
export default {"light":"Header_light__cKFU6","dark":"Header_dark__IS3Oy","header-item":"Header_header-item__ajukF","activeLink":"Header_activeLink__D5+gB","logout":"Header_logout__FUf24"};